import {api} from '@eksab/api';
import {AxiosError} from 'axios';
import {useQuery, UseQueryOptions} from '@tanstack/react-query';

export type DiscountVoucher = {
  code: string;
  discount_amount: number;
  order: {
    vat: number;
    total: number;
  };
};

type ValidateDiscountVoucherInput = {
  code: string;
  package_type: string;
  package_id: number | string;
};

const queryFn = (input: ValidateDiscountVoucherInput) =>
  api.post<{data: DiscountVoucher}>(`v3/discount-vouchers/validate`, input).then((res) => res.data.data);
const queryKey = (code: string) => ['voucher', code];

export function useDiscountVoucherCodeQuery(
  input: ValidateDiscountVoucherInput,
  options?: UseQueryOptions<DiscountVoucher, AxiosError>,
) {
  return useQuery<DiscountVoucher, AxiosError>(queryKey(input.code), () => queryFn(input), options);
}

useDiscountVoucherCodeQuery.queryFn = queryFn;
useDiscountVoucherCodeQuery.queryKey = queryKey;
